import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from 'react-select';

import { formateFeaturesForDropdown, formatEnumsForDropDown } from "../../utils/helperFunction";
import { Enumeration, Feature } from "../../utils/interface";
import { useFormik } from "formik";

interface NewPropertyFeatureFormProps {
  featureTypes: Enumeration[];
  onSelectFeatureType: (productFeatureTypeEnumId: number) => void;
  features: Feature[];
  PropertyFeatureValidationSchema: any;
  onCreatePropertyFeature: (propertyFeatureInfo: any) => void;
}

const NewPropertyFeatureForm: React.FC<NewPropertyFeatureFormProps> = ({
  featureTypes,
  onSelectFeatureType,
  features,
  PropertyFeatureValidationSchema,
  onCreatePropertyFeature,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      propertyFeatureId: undefined,
    },
    validationSchema: PropertyFeatureValidationSchema,
    onSubmit: (values, { resetForm }) => {
      onCreatePropertyFeature(values);
      resetForm();
      handleModalClose();
    }
  });

  return (<>
    <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
      Add Property Feature
    </Button>
    <Modal show={showModal} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add New Feature</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="type">
            <Form.Label>Type</Form.Label>
            <Select
              options={formatEnumsForDropDown(featureTypes)}
              isSearchable
              placeholder=""
              onChange={(selectedOption) => {
                if (selectedOption) {
                  onSelectFeatureType(selectedOption?.value)
                }
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="feature">
            <Form.Label>Feature</Form.Label>
            <Select
              options={formateFeaturesForDropdown(features)}
              isSearchable
              placeholder=""
              onChange={(selectedOption) =>
                formik.setFieldValue('propertyFeatureId', selectedOption?.value)
              }
            />
            {formik.touched.propertyFeatureId && formik.errors.propertyFeatureId ? (
              <Form.Text className="text-danger">
                {formik.errors.propertyFeatureId}
              </Form.Text>
            ) : null}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>Close</Button>
        <Button variant="primary" onClick={() => formik.handleSubmit()}>Add</Button>
      </Modal.Footer>
    </Modal>
  </>);
};

export default NewPropertyFeatureForm;
